import React from 'react';
import css from './SectionCategoriesDigo.module.css';

const TASKS = [
  {
    id: 1,
    avatar: '/static/worker-1.png',
    category: 'Entretien extérieur',
    title: 'Déneigement entrée 2 voitures + trottoir',
    stars: 5,
    price: '80 $',
    initials: 'ML',
  },
  {
    id: 2,
    avatar: '/static/worker-2.png',
    category: 'Montage & installation',
    title: 'Montage commode IKEA PAX + bibliothèque',
    stars: 5,
    price: '120 $',
    initials: 'JF',
  },
  {
    id: 3,
    avatar: '/static/worker-3.png',
    category: 'Aide à domicile',
    title: 'Grand ménage 4½ avant déménagement',
    stars: 5,
    price: '200 $',
    initials: 'SC',
  },
  {
    id: 4,
    avatar: '/static/worker-4.png',
    category: 'Animaux',
    title: 'Promenade chien 45 min × 3/semaine Plateau',
    stars: 5,
    price: '22 $/sortie',
    initials: 'MA',
  },
  {
    id: 5,
    avatar: '/static/worker-5.png',
    category: 'Soins & accompagnement',
    title: 'Accompagnement maman RDV médecin Laval',
    stars: 5,
    price: '55 $',
    initials: 'NB',
  },
  {
    id: 6,
    avatar: '/static/worker-6.png',
    category: 'Services pratiques',
    title: 'Attente livraison Vidéotron journée complète',
    stars: 5,
    price: '95 $',
    initials: 'PL',
  },
];

const Stars = ({ count }) => (
  <div className={css.stars} aria-label={`${count} étoiles sur 5`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <svg key={i} viewBox="0 0 12 12" className={css.star} aria-hidden="true">
        <polygon
          points="6 0.5 7.5 4.5 12 4.8 8.8 7.5 9.9 12 6 9.5 2.1 12 3.2 7.5 0 4.8 4.5 4.5"
          fill={i < count ? '#F59E0B' : '#E5E7EB'}
        />
      </svg>
    ))}
  </div>
);

const SectionCategoriesDigo = () => (
  <section className={css.root}>
    <div className={css.container}>
      <div className={css.header}>
        <h2 className={css.title}>Ce que font nos travailleurs</h2>
      </div>

      <div className={css.grid}>
        {TASKS.map(t => (
          <div key={t.id} className={css.card}>
            <div className={css.cardTop}>
              <img
                src={t.avatar}
                alt=""
                className={css.avatar}
                onError={e => { e.target.style.display = 'none'; }}
              />
              <div className={css.cardMeta}>
                <span className={css.category}>{t.category}</span>
                <Stars count={t.stars} />
              </div>
              <span className={css.price}>{t.price}</span>
            </div>
            <p className={css.taskTitle}>{t.title}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SectionCategoriesDigo;
